var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateNew2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2222_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 12.9536L27.1927 2.40674L20.3376 10.5268V29.4067H32.4999V12.9536Z",
    fill: "#BFD9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5317H21.1487V29.4067H2.5V12.5317Z",
    fill: "#EAF5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.98657,
    y: 17.5942,
    width: 4.86488,
    height: 5.0625,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2026,
    y: 19.2817,
    width: 4.05407,
    height: 10.125,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1156 2.40674H8.85525L2.5 12.5317H21.1487L27.1156 2.40674Z",
    fill: "#00C968"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 12.4067,
    rx: 7,
    ry: 5.5,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 11.4067,
    rx: 7,
    ry: 5.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6992 13.9067L23.1953 8.604H24.4648L25.4023 12.3345H25.4512L26.3984 8.604H27.6582L28.6152 12.3149H28.6641L29.5918 8.604H30.8613L29.3574 13.9067H28.0586L27.0625 10.313H26.9941L25.998 13.9067H24.6992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2222_176",
    x: 0.5,
    y: 2.40674,
    width: 35.5,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2222_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2222_176",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateNew2);
export default __webpack_public_path__ + "static/media/IcEstateNew_2.b74af6c926a0a0db479cd6f688293f48.svg";
export { ForwardRef as ReactComponent };